// extracted by mini-css-extract-plugin
export var deliveryRow = "_or-a";
export var fixedHeight = "_or-4";
export var freightLogo = "_or-9";
export var fullWidth = "_or-3";
export var priceColumn = "_or-5";
export var radioSelected = "_or-7";
export var radioUnselected = "_or-6";
export var selectedOption = "_or-2";
export var selectedOptionContainer = "_or-1";
export var selection = "_or-0";
export var tallSkeletonText = "_or-8";